import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Authenticate from './authenticate';

Vue.use(VueAxios, axios); //.......
const vueAuth = new Authenticate(Vue.prototype.$http, {
  loginUrl: 'auth/login',
  logoutUrl: 'auth/logout',
  responseDataKey: 'headers',
  registerUrl: 'user',
  //registerUrlEnterprise: 'user/enterprise',
  //registerUrlJudgement: 'user/judgement',
  userInfoUrl: 'auth/user',
  mobileAuthUrl: 'auth/user/certification/check',
  //tokenPath: 'user.token',
  //tokenHeader: 'X-AUTH-TOKEN',
  tokenPath: 'authorization',
  tokenHeader: 'Authorization',
  tokenType: '',
  tokenPrefix: `perce_${process.env.VUE_APP_APP_NAME}`,
  refreshTokenPath: 'refresh-authorization',
  refreshTokenHeader: 'Refresh-Authorization',
  refreshTokenType: '',
  refreshTokenPrefix: `perce_${process.env.VUE_APP_APP_NAME}`,
});

export default vueAuth;
